const heightReducer = (currentHeight = 0, action) => {
    switch(action.type) {
        case 'SET_HEIGHT':
            return currentHeight += action.payload;
        default:
            return currentHeight;
    }
};

export default heightReducer;